import React from 'react';
import { Link } from 'react-router-dom';
import { TOPICS } from './topics';
import styles from './Learn.module.css';

const LearnHub: React.FC = () => {
  return (
    <div className={styles.hub}>
      <header className={styles.hubHeader}>
        <h1>Learn SignalDeck</h1>
        <p>
          Short, honest explainers for the parts of the product people ask about most. If you prefer definitions over
          concepts, the <Link to="/glossary">Glossary</Link> has you covered too.
        </p>
      </header>
      <div className={styles.cardGrid}>
        {TOPICS.map((t) => (
          <Link key={t.slug} to={`/learn/${t.slug}`} className={styles.card}>
            <div className={styles.cardTopic}>{t.topicTag}</div>
            <h3 className={styles.cardTitle}>{t.title}</h3>
            <p className={styles.cardBlurb}>{t.blurb}</p>
            <div className={styles.cardMeta}>{t.readTime}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LearnHub;
